import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi/useApi.ts";
import type { SearchFilterParams } from "~pages/Conducts/ConductListPage/types/searchFilterParams.ts";
import type { UpsertConductData } from "~pages/Conducts/ConductUpsertModal/types/upsertConductData.ts";
import type { Conduct, ConductResponse } from "~types/conduct.ts";

export const useUpdateConduct = (params: SearchFilterParams) => {
  const { sport, organizationId } = useParams();
  const request = useApi();
  const queryClient = useQueryClient();

  return useMutation<ConductResponse, Error, UpsertConductData>({
    mutationFn: async (upsertModel: UpsertConductData) => {
      const url = `${sport}/o/${organizationId}/conduct/${upsertModel.conductId}`;
      return await request(url, { method: "PUT", body: upsertModel.upsertData });
    },
    onSuccess: async (response: { data: Array<Conduct> }) => {
      if (response?.data && response.data.length > 0) {
        await queryClient.invalidateQueries({
          queryKey: ["conducts", sport, organizationId, params],
        });
      }
    },
  });
};
